import { CALL_API } from '../../../middlewares/api';

import { STORAGE_KEY_CF_TOKEN } from '../../../constants/storage';
import { REQUEST_LOGIN, SUCCESS_LOGIN, FAILURE_LOGIN } from './constants';

import { updateInfos } from '../../account/actions';
import { forceFetchPartners } from '../../partner/actions';

export const loginUser = (creds, callback) => {
    const cloudflareCaptcha = sessionStorage.getItem(STORAGE_KEY_CF_TOKEN);

    return {
        [CALL_API]: {
            endpoint: '/auth/login',
            types: [REQUEST_LOGIN, SUCCESS_LOGIN, FAILURE_LOGIN],
            body: { ...creds, cloudflareCaptcha },
            successCallback: (response, dispatch) => {
                sessionStorage.removeItem(STORAGE_KEY_CF_TOKEN);
                dispatch(updateInfos(response.payload.user));
                dispatch(forceFetchPartners());
                if (callback) {
                    callback();
                }
            }
        }
    };
};



// WEBPACK FOOTER //
// ./src/services/authentication/login/actions.js